import React from 'react';
import PropTypes from 'prop-types';
import { useShowTooltip } from 'modules/utils/cp3/hooks';
import TooltipStyled from 'modules/utils/cp3/components/TooltipStyled';

const propTypes = {
	elementId: PropTypes.string,
	children: PropTypes.node,
	title: PropTypes.string,
};

const TooltipedText = ({ elementId = '', children, title, className }) => {
	const [showTooltip, textRef] = useShowTooltip();

	const text = (
		<div
			ref={textRef}
			className={`ellipsisText ${className}`}
			id={elementId}
			style={{ display: 'inline-block' }}
		>
			{children}
		</div>
	);

	if (showTooltip) {
		return (
			<TooltipStyled
				title={title}
				placement="bottom"
				id={`${elementId}-tooltip`}
			>
				{text}
			</TooltipStyled>
		);
	}

	return text;
};

TooltipedText.propTypes = propTypes;

export default TooltipedText;
